import React from 'react'
import SidebarCategory from './SidebarCategory'
const Sidebar = () => {
  return (
    <>
        <div className='sidebar'>
            <SidebarCategory />
        </div>
    </>
  )
}

export default Sidebar